module.exports = __webpack_public_path__ + "static/img/homeright4.7472a36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/homeright4.png
// module id = np/B
// module chunks = 13